const FOCUSABLE = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

export function getFieldElement(
  target: EventTarget | null
): HTMLElement | null {
  if (!(target instanceof HTMLElement)) {
    return null;
  }
  if (!FOCUSABLE.has(target.tagName)) {
    return null;
  }

  const field = target.closest('[data-field]');
  return field instanceof HTMLElement ? field : target;
}

/**
 * Scroll the field group (label + control) into view instead of the bare
 * input. iOS/Vaul otherwise pin the input to the top of the sheet scroller
 * and clip the label / the next field's tap target.
 */
export function scrollFieldIntoView(target: EventTarget | null): void {
  const field = getFieldElement(target);
  if (!field) {
    return;
  }

  field.scrollIntoView({ block: 'start', inline: 'nearest' });
}

export function scheduleScrollFieldIntoView(
  target: EventTarget | null,
  delay = 300
): number {
  return window.setTimeout(() => {
    scrollFieldIntoView(target);
  }, delay);
}
